import React, { useMemo } from "react";
import * as d3 from "d3";

const GREEN = "#0A8F08";
const YELLOW = "#D9B800";
const RED = "#D62828";

const PercentageGauge = ({
  percentage = 75,
  label = "Score",
  className = "",
  invert = false,
}) => {
  const value = Math.max(0, Math.min(100, percentage));

  const color = useMemo(() => {
    if (value >= 75) return invert ? RED : GREEN;
    if (value >= 25) return YELLOW;
    return invert ? GREEN : RED;
  }, [value, invert]);

  // SVG coordinate system
  const size = 300;
  const center = size / 2;

  const outerRadius = 120;
  const outerThickness = 35;

  const startAngle = -Math.PI * 2;
  const progressAngle = (value / 100) * Math.PI * 2;

  const backgroundArc = d3
    .arc()
    .innerRadius(outerRadius - outerThickness + 10)
    .outerRadius(outerRadius - 10)
    .startAngle(0)
    .endAngle(Math.PI * 2);

  const progressArc = d3
    .arc()
    .innerRadius(outerRadius - outerThickness)
    .outerRadius(outerRadius)
    .cornerRadius(4)
    .startAngle(startAngle)
    .endAngle(startAngle + progressAngle);

  return (
    <div
      className={className}
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          marginBottom: 0,
          fontSize: "1.5rem",
          fontWeight: 400,
          fontFamily: "Freeman",
          textAlign: "center",
        }}
      >
        {label}
      </div>

      <svg
        viewBox={`0 0 ${size} ${size}`}
        preserveAspectRatio="xMidYMid meet"
        style={{ width: "100%", height: "auto", display: "block" }}
      >
        <g transform={`translate(${center}, ${center})`}>
          {/* Outer gray ring */}
          <path
            d={backgroundArc()}
            fill="#D8D8D8"
          />

          {/* Colored progress */}
          {value > 0 && (
            <path
              d={progressArc()}
              fill={color}
              stroke="#FFFFFF"
              strokeWidth={5}
            />
          )}

          {/* Percentage */}
          <text
            x="0"
            y="14"
            textAnchor="middle"
            fill={color}
            fontWeight="700"
            fontSize="54"
            fontFamily="sans-serif"
          >
            {value}%
          </text>
        </g>
      </svg>
    </div>
  );
};

export default PercentageGauge;